<template>
	<div class="bankrecharge_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.push('/user')"></div>
			<div class="big_tit">{{ data.payment.bank }}</div>
		</div>
		<div class="bank_detail">
			<div class="item">
				<p class="info">
				{{$t('invest_qrcode.amount')}}
				<span>{{$t('utils.moneyMark')}}{{money}}</span>
				<span>{{actualAmount}}</span>
				</p>
			</div>
			<div class="item">
				<p class="info">{{$t('invest_bank.name')}}
				<span>{{ data.payment.username }}</span></p>
				<div class="copy_btn" v-clipboard="() => data.payment.username " v-clipboard:success="copy">
					{{$t('invest_bank.copy')}}
				</div>
			</div>
			<div class="item">
				<p class="info">{{$t('invest_bank.account')}}
				<span>{{ data.payment.account }}</span></p>
				<div class="copy_btn" v-clipboard="() => data.payment.account " v-clipboard:success="copy">
					{{$t('invest_bank.copy')}}
				</div>
			</div>
			<div class="item">
				<p class="info">{{$t('invest_bank.bank')}}
				<span>{{ data.payment.bank }}</span></p>
				<div class="copy_btn" v-clipboard="() => data.payment.bank " v-clipboard:success="copy">
					{{$t('invest_bank.copy')}}
				</div>
			</div>
			<div class="item remark_item">
				<label for="pay_remark" class="remark_label">备注：</label>
				<div class="remark_field">
					<textarea id="pay_remark" v-model.trim="pay_remark" maxlength="500" placeholder="请输入备注（选填）"></textarea>
					<span class="remark_count">{{ remarkLength }}/500</span>
				</div>
			</div>
		</div>
		<div class="basic_btn" :class="{ disabled: submitting }" @click="submitBtn">{{$t('utils.submit')}}</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Button
	} from "vant";
	import Fetch from "../../utils/fetch";
	import Clipboard from "v-clipboard";

	Vue.use(Button).use(Clipboard);

	export default {
		name: "invest_bank",
		data() {
			return {
				data: {},
				pay_remark: '',
				submitting: false,
				money: 0,
				actualAmount:'',
			};
		},
		created() {
			this.$parent.footer("user", false);
		},
		mounted() {
			this.money = this.$route.query.money ? this.$route.query.money : "";
			this.start();
		},
		computed: {
			remarkLength() {
				return Array.from(this.pay_remark || '').length;
			}
		},
		methods: {
			copy() {
				this.$toast({
					background: "#07c160",
					message: this.$t('invest_qrcode.copySucceeded'),
				});
			},
			start() {
				Fetch("/user/recharge_type", {
					money: this.$route.query.money ? this.$route.query.money : "",
					id:this.$route.query.id ? this.$route.query.id : ""
				}).then((r) => {
					this.data = r.data;
					this.changeAmount();
				});
			},
			submitBtn() {
				if (this.submitting) return;
				if (this.remarkLength > 500) {
					this.$toast('备注不能超过500个字符');
					return;
				}
				this.submitting = true;
				Fetch("/user/recharge_apply", {
					id: this.data.orderId,
					remark: this.pay_remark
				}).then((r) => {
					if (r.code == 1) {
						this.$toast({
							background: "#07c160",
							message: this.$t('invest_qrcode.submittedSuccessfully'),
						});
						this.$router.replace("/moneybag");
					}
				}).finally(() => {
					this.submitting = false;
				});
			},
			changeAmount() {
				this.actualAmount = this.money ? '(¥' + Number(this.money).toFixed(2) + ')' : '';
			}
		},
	};
</script>

<style lang="less" scoped>
	.bankrecharge_wrap {
		background: #fd1c5f !important;
		width: 100%;
		min-height: 100vh;
		box-sizing: border-box;
		padding-bottom: 30px;
		position: relative;
		overflow-y: auto;
	}
	.red_top_bg{
		background: #fd1c5f;
	}
	.bank_detail {
		width: 96%;
		margin-left: 2%;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-top: 12px;
		padding: 30px 16px;
		font-size: 14px;

		.item {
			height: 52px;
			border-bottom: 1px solid #ececec;
			line-height: 52px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.info {
				font-weight: bold;
				color: #000;
				span:nth-child(1){
					font-weight: initial;
				}
				span:nth-child(2){
					color: #999;
					font-size: 14px;
				}
			}

			.copy_btn {
				color: #3d96ff;
				font-size: 12px;
			}
		}

		.remark_item {
			height: auto;
			min-height: 112px;
			padding: 14px 0;
			line-height: 20px;
			align-items: flex-start;

			.remark_label {
				flex: none;
				font-weight: bold;
				color: #000;
				padding-top: 9px;
			}

			.remark_field {
				flex: 1;
				margin-left: 12px;
			}

			textarea {
				display: block;
				width: 100%;
				height: 72px;
				box-sizing: border-box;
				padding: 9px 10px;
				border: 1px solid #e5e5e5;
				border-radius: 5px;
				resize: vertical;
				font-size: 14px;
				line-height: 20px;
				color: #333;
			}

			.remark_count {
				display: block;
				margin-top: 4px;
				text-align: right;
				font-size: 12px;
				color: #999;
			}
		}
	}

	.warming {
		margin-top: 17px;
		padding: 0 14px;

		.tit {
			font-size: 14px;
			color: rgba(0, 0, 0, .8);
			line-height: 20px;
			font-weight: bold;
		}

		.content {
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			line-height: 17px;
			margin-top: 9px;
		}
	}

	.basic_btn {
		margin: 30px auto 0 auto;
		background: linear-gradient(90deg, #672ee4 0%, #16b4ff 100%);

		&.disabled {
			opacity: .6;
			pointer-events: none;
		}
	}
</style>
